module.exports = __webpack_public_path__ + "static/media/Aquecimento.7f3577ef.png";